import type { KeyboardEvent } from "react";
import { useState } from "react";

type UseKeyboardListNavOptions<T> = {
	onCommit: (item: T, index: number) => void;
	onEscape?: () => void;
};

export function useKeyboardListNav<T>(
	items: readonly T[],
	{ onCommit, onEscape }: UseKeyboardListNavOptions<T>,
) {
	const [activeIndex, setActiveIndex] = useState(0);
	const maxIndex = Math.max(0, items.length - 1);
	const clamped = Math.min(activeIndex, maxIndex);

	function onKeyDown(e: KeyboardEvent<HTMLInputElement>) {
		if (e.key === "ArrowDown") {
			e.preventDefault();
			setActiveIndex((i) => Math.min(i + 1, maxIndex));
		} else if (e.key === "ArrowUp") {
			e.preventDefault();
			setActiveIndex((i) => Math.max(i - 1, 0));
		} else if (e.key === "Enter") {
			e.preventDefault();
			const item = items[clamped];
			if (item !== undefined) onCommit(item, clamped);
		} else if (e.key === "Escape") {
			onEscape?.();
		}
	}

	return {
		activeIndex: clamped,
		setActiveIndex,
		onKeyDown,
		resetActiveIndex: () => setActiveIndex(0),
	};
}
